package navigation.home.edititineraryservice

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.waypoint.domain.WaypointClient
import com.essntl.features.address.domain.repository.AddressRepository
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.client.domain.repository.ClientRepository
import com.essntl.features.file.domain.repository.FileRepository
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.itinerary.domain.use_case.UpdateItineraryServiceUseCase
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceEvent
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceState
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceValidation
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceViewModel
import com.essntl.features.message.domain.repository.MessageRepository
import com.essntl.features.message.domain.useCase.SendItineraryMessageUseCase
import com.essntl.features.profile.domain.repository.ProfileRepository
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import com.essntl.features.request.domain.repository.RequestRepository
import com.essntl.features.service.domain.repository.ServiceRepository
import com.essntl.features.supplier.domain.repository.SupplierRepository
import com.essntl.features.task.domain.repository.TaskRepository
import com.essntl.features.task.domain.use_case.AddTaskUseCase
import com.essntl.features.task.domain.use_case.DeleteTaskUseCase
import com.essntl.features.task.domain.use_case.UpdateTaskUseCase
import com.essntl.toastmanager.ToastManager

class EditItineraryServiceScreenModel(
    taskRepository: TaskRepository,
    messageRepository: MessageRepository,
    supplierRepository: SupplierRepository,
    serviceRepository: ServiceRepository,
    categoryRepository: CategoryRepository,
    profileRepository: ProfileRepository,
    clientRepository: ClientRepository,
    requestRepository: RequestRepository,
    addressRepository: AddressRepository,
    itineraryRepository: ItineraryRepository,
    fileRepository: FileRepository,
    updateItineraryServiceUseCase: UpdateItineraryServiceUseCase,
    addTaskUseCase: AddTaskUseCase,
    updateTaskUseCase: UpdateTaskUseCase,
    deleteTaskUseCase: DeleteTaskUseCase,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    sendItineraryMessageUseCase: SendItineraryMessageUseCase,
    waypointClient: WaypointClient,
    loadingManager: LoadingManager,
    toastManager: ToastManager,
) : StateScreenModel<EditItineraryServiceState>(EditItineraryServiceState()) {
    val validation = EditItineraryServiceValidation()

    private val vm =
        EditItineraryServiceViewModel(
            taskRepository = taskRepository,
            messageRepository = messageRepository,
            supplierRepository = supplierRepository,
            serviceRepository = serviceRepository,
            categoryRepository = categoryRepository,
            profileRepository = profileRepository,
            clientRepository = clientRepository,
            requestRepository = requestRepository,
            itineraryRepository = itineraryRepository,
            addressRepository = addressRepository,
            fileRepository = fileRepository,
            updateItineraryServiceUseCase = updateItineraryServiceUseCase,
            addTaskUseCase = addTaskUseCase,
            updateTaskUseCase = updateTaskUseCase,
            deleteTaskUseCase = deleteTaskUseCase,
            getCurrentUserUseCase = getCurrentUserUseCase,
            sendItineraryMessageUseCase = sendItineraryMessageUseCase,
            waypointClient = waypointClient,
            toastManager = toastManager,
            validation = validation,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: EditItineraryServiceEvent) = vm.onEvent(event)
}
